import { CHECK_IF_VIEWER_FINISHED_SIGNUP } from '@marketplace/mixins/helpers.js'
/**
 * Redirect the user based on their account type and signup status.
 *
 * @param {object} root0
 * @param {object}  root0.store
 */
export default function ({ store }) {
    const account = store.getters['global/account'] || null
    const path = window.location.pathname
    const isExcludedPage = ['/email-settings'].some((excludedPath) =>
        path.includes(excludedPath)
    )

    if (!account || isExcludedPage) {
        return
    }

    const lowercaseAccountType = account.type.toLowerCase()
    const accountSignupIntent = account.signupIntent || null
    const redirectionUrl = CHECK_IF_VIEWER_FINISHED_SIGNUP(
        account.signupStatus,
        lowercaseAccountType,
        accountSignupIntent
    )

    if (redirectionUrl) {
        if (lowercaseAccountType === 'supplier') {
            window.location.href = '/signup/brands?step=info'
        } else {
            window.location.href = '/signup/retailers'
        }
    }
}
